<template>
  <div :class="$modal.fullWidth">
    <v-flex>
      <p :class="$modal.modalDangerText">
        Are you sure you want to cancel your entire order?
      </p>
    </v-flex>
    <v-flex :class="$modal.modalDangerButtons">
      <BaseButton :button-style="'Cancel'"
                  :class="$modal.noBtn">
        No
      </BaseButton>
      <BaseButton :button-style="'Danger'"
                  :class="$modal.dangerBtn">
        Yes, Cancel
      </BaseButton>
    </v-flex>
  </div>


</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import BaseButton from '@/components/BaseButton';

  @Component({
    name:       'CancelOrderModal',
    components: { BaseButton },
    props:      {
      closeHandler: () => {},
    },
  })
export default class CancelOrderModal extends Vue {
    show = false;

    close() {
      this.$emit('close');
    }
  }
</script>

<style src="@/style/modals.scss" lang="scss" module="$modal"></style>



// WEBPACK FOOTER //
// src/components/CancelOrderModal.vue